import React, { useContext, useState } from 'react';
// import AppImage from '../AppImage';

import styles from './styles.module.scss';
import { AdminContext } from '../../context/AdminContext';

import AppFormBox from '../AppFormBox';
import AppFormInput from '../AppFormInput';
import Api from '../../api';
import closeIcon from '../../../../assets/imgs/videoUpload/closeIcon.svg';
import addTag from '../../../../assets//imgs/videoUpload/add_tags.svg';
import addTagRed from '../../../../assets//imgs/videoUpload/add_tags_red.svg';


const TagInput = ({
  videoInformation,
  children,

  allTags,
  setAllTags,

  setPressed,
  content,
}) => {
  const [showTagAddBox, setShowTagAddBox] = useState(false);
  const [tagList, setTagList] = useState([]);
  const [tagState, setTagState] = useState('');

  const { themeMode } = useContext(AdminContext);

  const tagSearchFunction = (e) => {
    setTagState(e.target.value);
    // if (e.target.value.trim().length !== 0) {
    //   Api.tagList({
    //     params: {
    //       name: e.target.value,
    //       category_id: videoInformation.category.value,
    //     },
    //   })
    //     .then((res) => {
    //       setTagList(res.data.response);
    //     })
    //     .catch((err) => {});
    // } else {
    //   setTagList([]);
    // }
    setPressed(false);
  };
  const removeTag = (name, index) => {
    let filtered = [...allTags];
    const filtered2 = [...allTags];

    filtered = filtered2.splice(index, 1);
    setAllTags(filtered2);
    setPressed(false);
  };
  const addingTagFunction = (tag) => {
    if (tag.trim().length !== 0) {
      setAllTags([...allTags, tag]);
      setTagState('');
      setShowTagAddBox(!showTagAddBox);
    }
    setPressed(false);
  };
  const keyDownFunction = (e) => {
    if (e.keyCode == 13) {
      addingTagFunction(tagState);
      setPressed(false);

      e.preventDefault(); // this should prevent default action

      return false;
    }
    return true;
  };

  return (
    <>
      <AppFormBox
        className={`w-full`}
        wraperClassName={`w-full `}
        showError={videoInformation?.keywords?.errorTitle}
        showTitle={true}
        title={content?.tagTitle}
        error={content?.tagError}
        placeholder={content?.tagPlaceholder}
        showDescription={true}
        disabled={true}
        prefix0={
          <div
            className={`flex flex-row justofy-start align-center w-auto flex-wrap `}
          >
            {allTags?.length == 0 ? (
              <p className={styles.chooseText}>{content?.tag}</p>
            ) : (
              allTags.map((i, j) => (
                <div
                  key={j}
                  className={`${styles.singleTag} `}
                >
                  <div className={`w-auto preserveWhiteThemeColor`}>{`#${i}`}</div>
                  <img
                    alt='close'
                    src={closeIcon}
                    width={20}
                    height={20}
                    className='flex flex-row justify-center items-center mx-5px cursor-pointer box-border w-30px h-30px'
                    onClick={() => {
                      removeTag(i, j);
                    }}
                  />
                </div>
              ))
            )}
          </div>
        }
        affix={
          <img
            alt='add tag'
            src={
              !showTagAddBox
                ? addTag
                : addTagRed
            }
            width={20}
            height={20}
            className={`relative`}
            onClick={
              allTags.length < 12
                ? () => {
                    setShowTagAddBox(!showTagAddBox);
                    setTagList([]);
                  }
                : console.log('')
            }
            className='flex flex-row-reverse justify-start items-center w-auto cursor-pointer w-20px h-35px'
          />
        }
      >
        {children}
      </AppFormBox>
      {showTagAddBox && (
        <div
          className={`${styles.searchContainer} ${
            themeMode == 'dark' ? styles.dark : styles.white
          }`}
        >
          <div
            className={`${styles.writeTag} ${
              themeMode == 'dark' ? 'dark' : 'light'
            }`}
          >
            <AppFormInput
              onChange={(e) => tagSearchFunction(e)}
              className={`w-81`}
              // wraperClassName={`w-full `}
              wraperClassName={`${styles.input} w-full`}
              showError={false}
              showTitle={true}
              placeholder={content?.tag}
              showDescription={true}
              value={tagState}
              onKeyDown={(e) => {
                keyDownFunction(e);
              }}
            />
            <div
              onClick={() => {
                addingTagFunction(tagState);
              }}
              className={`${styles.addTag} preserveWhitethemeMode`}
            >
              <span>{content?.addTag}</span>
            </div>
          </div>
          <div
            className={`flex flex-col justify-start align-start cursor-pointer ${styles.tagBoxStyle}`}
          >
            {tagList.map((item, index) => (
              <p
                key={index}
                onClick={() => {
                  setTagState(item.name);
                  addingTagFunction(item.name);
                }}
              >
                {item.name}
              </p>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TagInput;
